export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "worker.df51f7e47b320ac5f09d.worker.js");
}
